import { bl_del_shipment_hdr_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class DeliveryShipmentHdrContainerModel extends BaseContainerModel {
  bl_del_shipment_hdr: bl_del_shipment_hdr_RowClass = new bl_del_shipment_hdr_RowClass();
}